import { store } from '../store/configure'

/**
 * Gets common analytics properties from the Redux store
 * These properties should be included with all analytics events
 * 
 * Note: Some properties like activeUsers and stripePaymentStatus are only available
 * in billing-specific queries and should be passed as overrides when available
 */
export function getAnalyticsProperties(overrides?: {
  activeUsers?: number
  stripePaymentStatus?: string
}) {
  const state = store.getState()
  const authCompany = state.authCompanySlice.authCompany

  return {
    companyId: authCompany?.id,
    plan: authCompany?.plan,
    platform: authCompany?.platform,
    subscriptionPeriod: authCompany?.billing?.subscriptionPeriod,
    // These properties are only available in billing queries, use overrides when available
    activeUsers: overrides?.activeUsers,
    stripePaymentStatus: overrides?.stripePaymentStatus,
  }
}

